// Auto-generated by build_icon_map_web.js
import I0 from './svg/font-awesome/regular/underline.svg';
import I1 from './svg/font-awesome/regular/trash.svg';
import I2 from './svg/font-awesome/regular/text.svg';
import I3 from './svg/font-awesome/regular/table.svg';
import I4 from './svg/font-awesome/regular/strikethrough.svg';
import I5 from './svg/font-awesome/regular/smiley.svg';
import I6 from './svg/font-awesome/regular/quote.svg';
import I7 from './svg/font-awesome/regular/picture.svg';
import I8 from './svg/font-awesome/regular/pencil.svg';
import I9 from './svg/font-awesome/regular/list-numbered.svg';
import I10 from './svg/font-awesome/regular/list-bulleted.svg';
import I11 from './svg/font-awesome/regular/link.svg';
import I12 from './svg/font-awesome/regular/italic.svg';
import I13 from './svg/font-awesome/regular/horizontal-line.svg';
import I14 from './svg/font-awesome/regular/h3.svg';
import I15 from './svg/font-awesome/regular/h2.svg';
import I16 from './svg/font-awesome/regular/h1.svg';
import I17 from './svg/font-awesome/regular/film.svg';
import I18 from './svg/font-awesome/regular/erasor.svg';
import I19 from './svg/font-awesome/regular/drag-handle.svg';
import I20 from './svg/font-awesome/regular/dot.svg';
import I21 from './svg/font-awesome/regular/dot-yellow.svg';
import I22 from './svg/font-awesome/regular/dot-red.svg';
import I23 from './svg/font-awesome/regular/dot-purple.svg';
import I24 from './svg/font-awesome/regular/dot-outline.svg';
import I25 from './svg/font-awesome/regular/dot-outline-yellow.svg';
import I26 from './svg/font-awesome/regular/dot-outline-red.svg';
import I27 from './svg/font-awesome/regular/dot-outline-purple.svg';
import I28 from './svg/font-awesome/regular/dot-outline-orange.svg';
import I29 from './svg/font-awesome/regular/dot-outline-olive.svg';
import I30 from './svg/font-awesome/regular/dot-outline-grey.svg';
import I31 from './svg/font-awesome/regular/dot-outline-brown.svg';
import I32 from './svg/font-awesome/regular/dot-outline-blue.svg';
import I33 from './svg/font-awesome/regular/dot-outline-black.svg';
import I34 from './svg/font-awesome/regular/dot-orange.svg';
import I35 from './svg/font-awesome/regular/dot-olive.svg';
import I36 from './svg/font-awesome/regular/dot-grey.svg';
import I37 from './svg/font-awesome/regular/dot-brown.svg';
import I38 from './svg/font-awesome/regular/dot-blue.svg';
import I39 from './svg/font-awesome/regular/dot-black.svg';
import I40 from './svg/font-awesome/regular/document-word.svg';
import I41 from './svg/font-awesome/regular/document-pdf.svg';
import I42 from './svg/font-awesome/regular/document-download.svg';
import I43 from './svg/font-awesome/regular/copy-block.svg';
import I44 from './svg/font-awesome/regular/column-4.svg';
import I45 from './svg/font-awesome/regular/column-3.svg';
import I46 from './svg/font-awesome/regular/column-2.svg';
import I47 from './svg/font-awesome/regular/column-1.svg';
import I48 from './svg/font-awesome/regular/circle-line-part.svg';
import I49 from './svg/font-awesome/regular/chevron-up.svg';
import I50 from './svg/font-awesome/regular/chevron-right.svg';
import I51 from './svg/font-awesome/regular/chevron-left.svg';
import I52 from './svg/font-awesome/regular/chevron-down.svg';
import I53 from './svg/font-awesome/regular/checked.svg';
import I54 from './svg/font-awesome/regular/checkbox-checked.svg';
import I55 from './svg/font-awesome/regular/bold.svg';
import I56 from './svg/font-awesome/regular/at-sign.svg';
import I57 from './svg/font-awesome/regular/arrow-to-line-up.svg';
import I58 from './svg/font-awesome/regular/arrow-to-line-right.svg';
import I59 from './svg/font-awesome/regular/arrow-to-line-left.svg';
import I60 from './svg/font-awesome/regular/arrow-to-line-down.svg';
import I61 from './svg/font-awesome/regular/arrow-corner-right-down.svg';
import I62 from './svg/font-awesome/regular/arrow-circle-right.svg';
import I63 from './svg/font-awesome/regular/arrow-circle-left.svg';
import I64 from './svg/font-awesome/regular/align-right.svg';
import I65 from './svg/font-awesome/regular/align-left.svg';
import I66 from './svg/font-awesome/regular/align-justify.svg';
import I67 from './svg/font-awesome/regular/align-center.svg';
import I68 from './svg/flaticon/solid/question-mark-circled.svg';
import I69 from './svg/flaticon/solid/exclamation-mark-circled.svg';
import I70 from './svg/flaticon/regular/world.svg';
import I71 from './svg/flaticon/regular/video.svg';
import I72 from './svg/flaticon/regular/upload.svg';
import I73 from './svg/flaticon/regular/unlocked.svg';
import I74 from './svg/flaticon/regular/typography.svg';
import I75 from './svg/flaticon/regular/trash.svg';
import I76 from './svg/flaticon/regular/tools.svg';
import I77 from './svg/flaticon/regular/thumbs-up.svg';
import I78 from './svg/flaticon/regular/three-sliders.svg';
import I79 from './svg/flaticon/regular/three-lines.svg';
import I80 from './svg/flaticon/regular/three-dots.svg';
import I81 from './svg/flaticon/regular/thermometer.svg';
import I82 from './svg/flaticon/regular/test-tube.svg';
import I83 from './svg/flaticon/regular/tent.svg';
import I84 from './svg/flaticon/regular/sun.svg';
import I85 from './svg/flaticon/regular/stopwatch.svg';
import I86 from './svg/flaticon/regular/spinner.svg';
import I87 from './svg/flaticon/regular/smiley.svg';
import I88 from './svg/flaticon/regular/smartphone.svg';
import I89 from './svg/flaticon/regular/shop.svg';
import I90 from './svg/flaticon/regular/question-mark.svg';
import I91 from './svg/flaticon/regular/question-mark-circled.svg';
import I92 from './svg/flaticon/regular/push-pin.svg';
import I93 from './svg/flaticon/regular/plus.svg';
import I94 from './svg/flaticon/regular/plus-small.svg';
import I95 from './svg/flaticon/regular/plus-circled.svg';
import I96 from './svg/flaticon/regular/play.svg';
import I97 from './svg/flaticon/regular/plane.svg';
import I98 from './svg/flaticon/regular/ping-pong.svg';
import I99 from './svg/flaticon/regular/pin.svg';
import I100 from './svg/flaticon/regular/picture.svg';
import I101 from './svg/flaticon/regular/phone.svg';
import I102 from './svg/flaticon/regular/person.svg';
import I103 from './svg/flaticon/regular/person-plus.svg';
import I104 from './svg/flaticon/regular/person-minus.svg';
import I105 from './svg/flaticon/regular/person-cross.svg';
import I106 from './svg/flaticon/regular/percentage-arrow.svg';
import I107 from './svg/flaticon/regular/pencil.svg';
import I108 from './svg/flaticon/regular/pause.svg';
import I109 from './svg/flaticon/regular/paperclip.svg';
import I110 from './svg/flaticon/regular/paper-plane.svg';
import I111 from './svg/flaticon/regular/musical-note.svg';
import I112 from './svg/flaticon/regular/minus.svg';
import I113 from './svg/flaticon/regular/minus-small.svg';
import I114 from './svg/flaticon/regular/megaphone.svg';
import I115 from './svg/flaticon/regular/map.svg';
import I116 from './svg/flaticon/regular/map-marker-cross.svg';
import I117 from './svg/flaticon/regular/magnifying-glass.svg';
import I118 from './svg/flaticon/regular/magnifying-glass-plus.svg';
import I119 from './svg/flaticon/regular/magnifying-glass-minus.svg';
import I120 from './svg/flaticon/regular/locked.svg';
import I121 from './svg/flaticon/regular/list.svg';
import I122 from './svg/flaticon/regular/list copy.svg';
import I123 from './svg/flaticon/regular/link.svg';
import I124 from './svg/flaticon/regular/light-bulb.svg';
import I125 from './svg/flaticon/regular/lifebuoy.svg';
import I126 from './svg/flaticon/regular/letter-p.svg';
import I127 from './svg/flaticon/regular/letter-p-circled.svg';
import I128 from './svg/flaticon/regular/knife-fork.svg';
import I129 from './svg/flaticon/regular/key.svg';
import I130 from './svg/flaticon/regular/info.svg';
import I131 from './svg/flaticon/regular/infinity.svg';
import I132 from './svg/flaticon/regular/ice-cream.svg';
import I133 from './svg/flaticon/regular/house.svg';
import I134 from './svg/flaticon/regular/hourglass.svg';
import I135 from './svg/flaticon/regular/histogram.svg';
import I136 from './svg/flaticon/regular/heart.svg';
import I137 from './svg/flaticon/regular/gym-barbell.svg';
import I138 from './svg/flaticon/regular/graph-arrow.svg';
import I139 from './svg/flaticon/regular/graduation-hat.svg';
import I140 from './svg/flaticon/regular/glasses.svg';
import I141 from './svg/flaticon/regular/glasses-cheers.svg';
import I142 from './svg/flaticon/regular/glass-with-straw.svg';
import I143 from './svg/flaticon/regular/flower.svg';
import I144 from './svg/flaticon/regular/floppy.svg';
import I145 from './svg/flaticon/regular/flag.svg';
import I146 from './svg/flaticon/regular/flag-nl.svg';
import I147 from './svg/flaticon/regular/flag-en.svg';
import I148 from './svg/flaticon/regular/filter.svg';
import I149 from './svg/flaticon/regular/film.svg';
import I150 from './svg/flaticon/regular/fi-rr-sunrise.svg';
import I151 from './svg/flaticon/regular/eye-open.svg';
import I152 from './svg/flaticon/regular/eye-closed.svg';
import I153 from './svg/flaticon/regular/external-link.svg';
import I154 from './svg/flaticon/regular/exclamation-mark.svg';
import I155 from './svg/flaticon/regular/exclamation-mark-circled.svg';
import I156 from './svg/flaticon/regular/exclamation-circled.svg';
import I157 from './svg/flaticon/regular/euro.svg';
import I158 from './svg/flaticon/regular/envelope.svg';
import I159 from './svg/flaticon/regular/drag-handle.svg';
import I160 from './svg/flaticon/regular/download.svg';
import I161 from './svg/flaticon/regular/dot.svg';
import I162 from './svg/flaticon/regular/dot-small.svg';
import I163 from './svg/flaticon/regular/document.svg';
import I164 from './svg/flaticon/regular/document-signed.svg';
import I165 from './svg/flaticon/regular/document-blank.svg';
import I166 from './svg/flaticon/regular/diamond.svg';
import I167 from './svg/flaticon/regular/delete-keystroke.svg';
import I168 from './svg/flaticon/regular/cross.svg';
import I169 from './svg/flaticon/regular/cross-small.svg';
import I170 from './svg/flaticon/regular/cross-circled.svg';
import I171 from './svg/flaticon/regular/croissant.svg';
import I172 from './svg/flaticon/regular/credit-card.svg';
import I173 from './svg/flaticon/regular/copy.svg';
import I174 from './svg/flaticon/regular/copy-block.svg';
import I175 from './svg/flaticon/regular/confetti.svg';
import I176 from './svg/flaticon/regular/computer-server-exchange.svg';
import I177 from './svg/flaticon/regular/comment-with-text.svg';
import I178 from './svg/flaticon/regular/cog-wheel.svg';
import I179 from './svg/flaticon/regular/cloud-upload.svg';
import I180 from './svg/flaticon/regular/clock.svg';
import I181 from './svg/flaticon/regular/clock-with-plus.svg';
import I182 from './svg/flaticon/regular/clock-with-dotted-line.svg';
import I183 from './svg/flaticon/regular/clock-with-cross.svg';
import I184 from './svg/flaticon/regular/clock-with-check.svg';
import I185 from './svg/flaticon/regular/clock-with-arrow-left.svg';
import I186 from './svg/flaticon/regular/clock-arrow.svg';
import I187 from './svg/flaticon/regular/circle.svg';
import I188 from './svg/flaticon/regular/chevron-up.svg';
import I189 from './svg/flaticon/regular/chevron-small-up.svg';
import I190 from './svg/flaticon/regular/chevron-small-right.svg';
import I191 from './svg/flaticon/regular/chevron-small-left.svg';
import I192 from './svg/flaticon/regular/chevron-small-down.svg';
import I193 from './svg/flaticon/regular/chevron-right.svg';
import I194 from './svg/flaticon/regular/chevron-left.svg';
import I195 from './svg/flaticon/regular/chevron-down.svg';
import I196 from './svg/flaticon/regular/checked.svg';
import I197 from './svg/flaticon/regular/checkbox-unchecked.svg';
import I198 from './svg/flaticon/regular/checkbox-indeterminate-filled.svg';
import I199 from './svg/flaticon/regular/checkbox-disabled.svg';
import I200 from './svg/flaticon/regular/checkbox-checked.svg';
import I201 from './svg/flaticon/regular/checkbox-checked-colored.svg';
import I202 from './svg/flaticon/regular/chat.svg';
import I203 from './svg/flaticon/regular/chart-circles.svg';
import I204 from './svg/flaticon/regular/caret-up.svg';
import I205 from './svg/flaticon/regular/caret-right.svg';
import I206 from './svg/flaticon/regular/caret-left.svg';
import I207 from './svg/flaticon/regular/caret-down.svg';
import I208 from './svg/flaticon/regular/calendar.svg';
import I209 from './svg/flaticon/regular/building.svg';
import I210 from './svg/flaticon/regular/bug.svg';
import I211 from './svg/flaticon/regular/book.svg';
import I212 from './svg/flaticon/regular/block.svg';
import I213 from './svg/flaticon/regular/birthday-cake.svg';
import I214 from './svg/flaticon/regular/bell.svg';
import I215 from './svg/flaticon/regular/bed.svg';
import I216 from './svg/flaticon/regular/baby.svg';
import I217 from './svg/flaticon/regular/arrow-up.svg';
import I218 from './svg/flaticon/regular/arrow-up-down.svg';
import I219 from './svg/flaticon/regular/arrow-undo.svg';
import I220 from './svg/flaticon/regular/arrow-small-up.svg';
import I221 from './svg/flaticon/regular/arrow-small-right.svg';
import I222 from './svg/flaticon/regular/arrow-small-left.svg';
import I223 from './svg/flaticon/regular/arrow-small-hook-right.svg';
import I224 from './svg/flaticon/regular/arrow-small-down.svg';
import I225 from './svg/flaticon/regular/arrow-right.svg';
import I226 from './svg/flaticon/regular/arrow-redo.svg';
import I227 from './svg/flaticon/regular/arrow-left.svg';
import I228 from './svg/flaticon/regular/arrow-left-right.svg';
import I229 from './svg/flaticon/regular/arrow-down.svg';
import I230 from './svg/flaticon/regular/arrow-circle.svg';
import I231 from './svg/flaticon/regular/arrow-circle-right.svg';
import I232 from './svg/flaticon/regular/arrow-circle-left.svg';
import I233 from './svg/flaticon/regular/apple.svg';
import I234 from './svg/flaticon/regular/ambulance.svg';
import I235 from './svg/flaticon/bold/thumbs-up.svg';
import I236 from './svg/flaticon/bold/three-lines.svg';
import I237 from './svg/flaticon/bold/three-dots.svg';
import I238 from './svg/flaticon/bold/paper-plane.svg';
import I239 from './svg/flaticon/bold/graduation-hat.svg';
import I240 from './svg/flaticon/bold/cross.svg';
import I241 from './svg/flaticon/bold/clock.svg';
import I242 from './svg/flaticon/bold/checked.svg';
import I243 from './svg/flaticon/bold/chat.svg';
import I244 from './svg/flaticon/bold/arrow-small-right.svg';
import I245 from './svg/flaticon/bold/arrow-small-left.svg';
import I246 from './svg/eitje/regular/loading.svg';
export const iconMap = {
  'font-awesome/regular/underline': I0,
  'font-awesome/regular/trash': I1,
  'font-awesome/regular/text': I2,
  'font-awesome/regular/table': I3,
  'font-awesome/regular/strikethrough': I4,
  'font-awesome/regular/smiley': I5,
  'font-awesome/regular/quote': I6,
  'font-awesome/regular/picture': I7,
  'font-awesome/regular/pencil': I8,
  'font-awesome/regular/list-numbered': I9,
  'font-awesome/regular/list-bulleted': I10,
  'font-awesome/regular/link': I11,
  'font-awesome/regular/italic': I12,
  'font-awesome/regular/horizontal-line': I13,
  'font-awesome/regular/h3': I14,
  'font-awesome/regular/h2': I15,
  'font-awesome/regular/h1': I16,
  'font-awesome/regular/film': I17,
  'font-awesome/regular/erasor': I18,
  'font-awesome/regular/drag-handle': I19,
  'font-awesome/regular/dot': I20,
  'font-awesome/regular/dot-yellow': I21,
  'font-awesome/regular/dot-red': I22,
  'font-awesome/regular/dot-purple': I23,
  'font-awesome/regular/dot-outline': I24,
  'font-awesome/regular/dot-outline-yellow': I25,
  'font-awesome/regular/dot-outline-red': I26,
  'font-awesome/regular/dot-outline-purple': I27,
  'font-awesome/regular/dot-outline-orange': I28,
  'font-awesome/regular/dot-outline-olive': I29,
  'font-awesome/regular/dot-outline-grey': I30,
  'font-awesome/regular/dot-outline-brown': I31,
  'font-awesome/regular/dot-outline-blue': I32,
  'font-awesome/regular/dot-outline-black': I33,
  'font-awesome/regular/dot-orange': I34,
  'font-awesome/regular/dot-olive': I35,
  'font-awesome/regular/dot-grey': I36,
  'font-awesome/regular/dot-brown': I37,
  'font-awesome/regular/dot-blue': I38,
  'font-awesome/regular/dot-black': I39,
  'font-awesome/regular/document-word': I40,
  'font-awesome/regular/document-pdf': I41,
  'font-awesome/regular/document-download': I42,
  'font-awesome/regular/copy-block': I43,
  'font-awesome/regular/column-4': I44,
  'font-awesome/regular/column-3': I45,
  'font-awesome/regular/column-2': I46,
  'font-awesome/regular/column-1': I47,
  'font-awesome/regular/circle-line-part': I48,
  'font-awesome/regular/chevron-up': I49,
  'font-awesome/regular/chevron-right': I50,
  'font-awesome/regular/chevron-left': I51,
  'font-awesome/regular/chevron-down': I52,
  'font-awesome/regular/checked': I53,
  'font-awesome/regular/checkbox-checked': I54,
  'font-awesome/regular/bold': I55,
  'font-awesome/regular/at-sign': I56,
  'font-awesome/regular/arrow-to-line-up': I57,
  'font-awesome/regular/arrow-to-line-right': I58,
  'font-awesome/regular/arrow-to-line-left': I59,
  'font-awesome/regular/arrow-to-line-down': I60,
  'font-awesome/regular/arrow-corner-right-down': I61,
  'font-awesome/regular/arrow-circle-right': I62,
  'font-awesome/regular/arrow-circle-left': I63,
  'font-awesome/regular/align-right': I64,
  'font-awesome/regular/align-left': I65,
  'font-awesome/regular/align-justify': I66,
  'font-awesome/regular/align-center': I67,
  'flaticon/solid/question-mark-circled': I68,
  'flaticon/solid/exclamation-mark-circled': I69,
  'flaticon/regular/world': I70,
  'flaticon/regular/video': I71,
  'flaticon/regular/upload': I72,
  'flaticon/regular/unlocked': I73,
  'flaticon/regular/typography': I74,
  'flaticon/regular/trash': I75,
  'flaticon/regular/tools': I76,
  'flaticon/regular/thumbs-up': I77,
  'flaticon/regular/three-sliders': I78,
  'flaticon/regular/three-lines': I79,
  'flaticon/regular/three-dots': I80,
  'flaticon/regular/thermometer': I81,
  'flaticon/regular/test-tube': I82,
  'flaticon/regular/tent': I83,
  'flaticon/regular/sun': I84,
  'flaticon/regular/stopwatch': I85,
  'flaticon/regular/spinner': I86,
  'flaticon/regular/smiley': I87,
  'flaticon/regular/smartphone': I88,
  'flaticon/regular/shop': I89,
  'flaticon/regular/question-mark': I90,
  'flaticon/regular/question-mark-circled': I91,
  'flaticon/regular/push-pin': I92,
  'flaticon/regular/plus': I93,
  'flaticon/regular/plus-small': I94,
  'flaticon/regular/plus-circled': I95,
  'flaticon/regular/play': I96,
  'flaticon/regular/plane': I97,
  'flaticon/regular/ping-pong': I98,
  'flaticon/regular/pin': I99,
  'flaticon/regular/picture': I100,
  'flaticon/regular/phone': I101,
  'flaticon/regular/person': I102,
  'flaticon/regular/person-plus': I103,
  'flaticon/regular/person-minus': I104,
  'flaticon/regular/person-cross': I105,
  'flaticon/regular/percentage-arrow': I106,
  'flaticon/regular/pencil': I107,
  'flaticon/regular/pause': I108,
  'flaticon/regular/paperclip': I109,
  'flaticon/regular/paper-plane': I110,
  'flaticon/regular/musical-note': I111,
  'flaticon/regular/minus': I112,
  'flaticon/regular/minus-small': I113,
  'flaticon/regular/megaphone': I114,
  'flaticon/regular/map': I115,
  'flaticon/regular/map-marker-cross': I116,
  'flaticon/regular/magnifying-glass': I117,
  'flaticon/regular/magnifying-glass-plus': I118,
  'flaticon/regular/magnifying-glass-minus': I119,
  'flaticon/regular/locked': I120,
  'flaticon/regular/list': I121,
  'flaticon/regular/list copy': I122,
  'flaticon/regular/link': I123,
  'flaticon/regular/light-bulb': I124,
  'flaticon/regular/lifebuoy': I125,
  'flaticon/regular/letter-p': I126,
  'flaticon/regular/letter-p-circled': I127,
  'flaticon/regular/knife-fork': I128,
  'flaticon/regular/key': I129,
  'flaticon/regular/info': I130,
  'flaticon/regular/infinity': I131,
  'flaticon/regular/ice-cream': I132,
  'flaticon/regular/house': I133,
  'flaticon/regular/hourglass': I134,
  'flaticon/regular/histogram': I135,
  'flaticon/regular/heart': I136,
  'flaticon/regular/gym-barbell': I137,
  'flaticon/regular/graph-arrow': I138,
  'flaticon/regular/graduation-hat': I139,
  'flaticon/regular/glasses': I140,
  'flaticon/regular/glasses-cheers': I141,
  'flaticon/regular/glass-with-straw': I142,
  'flaticon/regular/flower': I143,
  'flaticon/regular/floppy': I144,
  'flaticon/regular/flag': I145,
  'flaticon/regular/flag-nl': I146,
  'flaticon/regular/flag-en': I147,
  'flaticon/regular/filter': I148,
  'flaticon/regular/film': I149,
  'flaticon/regular/fi-rr-sunrise': I150,
  'flaticon/regular/eye-open': I151,
  'flaticon/regular/eye-closed': I152,
  'flaticon/regular/external-link': I153,
  'flaticon/regular/exclamation-mark': I154,
  'flaticon/regular/exclamation-mark-circled': I155,
  'flaticon/regular/exclamation-circled': I156,
  'flaticon/regular/euro': I157,
  'flaticon/regular/envelope': I158,
  'flaticon/regular/drag-handle': I159,
  'flaticon/regular/download': I160,
  'flaticon/regular/dot': I161,
  'flaticon/regular/dot-small': I162,
  'flaticon/regular/document': I163,
  'flaticon/regular/document-signed': I164,
  'flaticon/regular/document-blank': I165,
  'flaticon/regular/diamond': I166,
  'flaticon/regular/delete-keystroke': I167,
  'flaticon/regular/cross': I168,
  'flaticon/regular/cross-small': I169,
  'flaticon/regular/cross-circled': I170,
  'flaticon/regular/croissant': I171,
  'flaticon/regular/credit-card': I172,
  'flaticon/regular/copy': I173,
  'flaticon/regular/copy-block': I174,
  'flaticon/regular/confetti': I175,
  'flaticon/regular/computer-server-exchange': I176,
  'flaticon/regular/comment-with-text': I177,
  'flaticon/regular/cog-wheel': I178,
  'flaticon/regular/cloud-upload': I179,
  'flaticon/regular/clock': I180,
  'flaticon/regular/clock-with-plus': I181,
  'flaticon/regular/clock-with-dotted-line': I182,
  'flaticon/regular/clock-with-cross': I183,
  'flaticon/regular/clock-with-check': I184,
  'flaticon/regular/clock-with-arrow-left': I185,
  'flaticon/regular/clock-arrow': I186,
  'flaticon/regular/circle': I187,
  'flaticon/regular/chevron-up': I188,
  'flaticon/regular/chevron-small-up': I189,
  'flaticon/regular/chevron-small-right': I190,
  'flaticon/regular/chevron-small-left': I191,
  'flaticon/regular/chevron-small-down': I192,
  'flaticon/regular/chevron-right': I193,
  'flaticon/regular/chevron-left': I194,
  'flaticon/regular/chevron-down': I195,
  'flaticon/regular/checked': I196,
  'flaticon/regular/checkbox-unchecked': I197,
  'flaticon/regular/checkbox-indeterminate-filled': I198,
  'flaticon/regular/checkbox-disabled': I199,
  'flaticon/regular/checkbox-checked': I200,
  'flaticon/regular/checkbox-checked-colored': I201,
  'flaticon/regular/chat': I202,
  'flaticon/regular/chart-circles': I203,
  'flaticon/regular/caret-up': I204,
  'flaticon/regular/caret-right': I205,
  'flaticon/regular/caret-left': I206,
  'flaticon/regular/caret-down': I207,
  'flaticon/regular/calendar': I208,
  'flaticon/regular/building': I209,
  'flaticon/regular/bug': I210,
  'flaticon/regular/book': I211,
  'flaticon/regular/block': I212,
  'flaticon/regular/birthday-cake': I213,
  'flaticon/regular/bell': I214,
  'flaticon/regular/bed': I215,
  'flaticon/regular/baby': I216,
  'flaticon/regular/arrow-up': I217,
  'flaticon/regular/arrow-up-down': I218,
  'flaticon/regular/arrow-undo': I219,
  'flaticon/regular/arrow-small-up': I220,
  'flaticon/regular/arrow-small-right': I221,
  'flaticon/regular/arrow-small-left': I222,
  'flaticon/regular/arrow-small-hook-right': I223,
  'flaticon/regular/arrow-small-down': I224,
  'flaticon/regular/arrow-right': I225,
  'flaticon/regular/arrow-redo': I226,
  'flaticon/regular/arrow-left': I227,
  'flaticon/regular/arrow-left-right': I228,
  'flaticon/regular/arrow-down': I229,
  'flaticon/regular/arrow-circle': I230,
  'flaticon/regular/arrow-circle-right': I231,
  'flaticon/regular/arrow-circle-left': I232,
  'flaticon/regular/apple': I233,
  'flaticon/regular/ambulance': I234,
  'flaticon/bold/thumbs-up': I235,
  'flaticon/bold/three-lines': I236,
  'flaticon/bold/three-dots': I237,
  'flaticon/bold/paper-plane': I238,
  'flaticon/bold/graduation-hat': I239,
  'flaticon/bold/cross': I240,
  'flaticon/bold/clock': I241,
  'flaticon/bold/checked': I242,
  'flaticon/bold/chat': I243,
  'flaticon/bold/arrow-small-right': I244,
  'flaticon/bold/arrow-small-left': I245,
  'eitje/regular/loading': I246
};
export default iconMap;
